const formatBytesFlexible = (bytes: number, k: number, decimals: number) => {
  if (bytes === 0) return '0 Bytes';
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const formatBytesBinary = (bytes: number, decimals = 2) =>
  formatBytesFlexible(bytes, 1024, decimals);

export const formatBytesDecimal = (bytes: number, decimals = 2) =>
  formatBytesFlexible(bytes, 1000, decimals);
